import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    achieving = '',
    exec = '',
    scoreTotal = 0,
    oExec = 0,
    oScoreTotal = 0,
    inputName = '',
    contactPer = '',
    contactTel = '',
    details = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projAppraise.save, {
        id,
        achieving,
        exec,
        scoreTotal,
        oExec,
        oScoreTotal,
        inputName,
        contactPer,
        contactTel,
        details,
    }, options);
    if (error) return { error, status };
    return content || { info: {}, rows: [] };
};
